import BaseModel from '@kakadu-dev/base-frontend-helpers/models/BaseModel';
import { inventoryTypes } from "./enums";
/**
 * Company inventory model
 */

export class CompanyInventory extends BaseModel {
  constructor(...args) {
    super(...args);

    this.getExistProductsCount = () => {
      return this.model.existProductsCount;
    };

    this.getMissingProductsCount = () => {
      return this.model.missingProductsCount;
    };

    this.getTagsInZonesCount = () => {
      return this.model.tagsInZonesCount;
    };

    this.getTagsInMissingZone = () => {
      return this.model.tagsInZonesCount && this.model.tagsInZonesCount.missing || [];
    };

    this.getTagsInExistZone = () => {
      return this.model.tagsInZonesCount && this.model.tagsInZonesCount.exist || [];
    };

    this.getZonesList = () => {
      return this.model.zonesList;
    };
  }

  /**
   * Create company inventory
   *
   * @param {object} object
   *
   * @return {CompanyInventory}
   */
  static create(object) {
    return super.create(object);
  }
  /**
   * Get exist products count
   *
   * @return {number}
   */


}
CompanyInventory.types = inventoryTypes;